import { render, staticRenderFns } from "./CoronarografiaPtcaView.vue?vue&type=template&id=2526bd64"
import script from "./CoronarografiaPtcaView.vue?vue&type=script&lang=js"
export * from "./CoronarografiaPtcaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports